declare global {
  interface Window {
    __AIRA_OUTLOOK_RUNTIME_CONFIG__?: {
      entraClientId?: string;
      idpProjectId?: string;
      idpWebApiKey?: string;
    };
  }
}

/** Identity Platform web SDK config. GKE runtime config wins over build-time defaults. */
export function getIdpConfig(): { projectId: string; apiKey: string } {
  const runtimeProjectId = window.__AIRA_OUTLOOK_RUNTIME_CONFIG__?.idpProjectId?.trim();
  const runtimeApiKey = window.__AIRA_OUTLOOK_RUNTIME_CONFIG__?.idpWebApiKey?.trim();

  // Treat the runtime pair atomically so a partial GKE configuration can never
  // combine a sharefox project ID with a legacy Cloud Run API key (or vice versa).
  if (runtimeProjectId || runtimeApiKey) {
    if (!runtimeProjectId || !runtimeApiKey) {
      throw new Error(
        'Identity Platform runtime config incomplete: set both IDP_PROJECT_ID and IDP_WEB_API_KEY.',
      );
    }
    return { projectId: runtimeProjectId, apiKey: runtimeApiKey };
  }

  const projectId = (import.meta.env.VITE_IDP_PROJECT_ID as string | undefined)?.trim() || '';
  const apiKey = (import.meta.env.VITE_IDP_WEB_API_KEY as string | undefined)?.trim() || '';

  if (!projectId || !apiKey) {
    throw new Error(
      'Identity Platform config missing: set IDP_PROJECT_ID and IDP_WEB_API_KEY at runtime or their VITE_IDP_* fallbacks.',
    );
  }

  return { projectId, apiKey };
}

/** Microsoft Entra client ID. GKE runtime config wins over build-time defaults. */
export function getEntraClientId(): string {
  const runtimeClientId = window.__AIRA_OUTLOOK_RUNTIME_CONFIG__?.entraClientId?.trim();
  if (runtimeClientId) return runtimeClientId;

  return (import.meta.env.VITE_ENTRA_CLIENT_ID as string | undefined)?.trim() ?? '';
}
